var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    checked: _vm.value,
    unchecked: !_vm.value,
    disabled: _vm.disabled
  }},[_c('label',{staticClass:"cursor-pointer flex flex-row items-center"},[_c('div',{staticClass:"rail"},[_c('input',{staticClass:"hidden",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('div',{staticClass:"knob rounded-full shadow-sm h-4 w-4"})]),_c('span',{staticClass:"ml-2 text-app-med"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }